import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { applyPageMetadata, applyStructuredData } from '../utils/seo';

export default function BartenderJobsLasVegasPage() {
  useEffect(() => {
    const cleanupMeta = applyPageMetadata({
      title: 'Bartender Jobs in Las Vegas, NV | BarsConnect',
      description: 'Find bartender jobs in Las Vegas, Nevada. Discover casino lounge, nightclub, and event shift opportunities with direct hiring access.',
      keywords: 'bartender jobs las vegas nv, vegas bartender shifts, casino bartender jobs, nightlife jobs las vegas, event bartending las vegas',
      canonicalUrl: 'https://barsconnect.com/bartender-jobs-las-vegas-nv',
      ogTitle: 'Bartender Jobs in Las Vegas, NV | BarsConnect',
      ogDescription: 'Browse bartender opportunities across Las Vegas nightlife and events.',
      twitterTitle: 'Bartender Jobs in Las Vegas, NV | BarsConnect',
      twitterDescription: 'Connect directly with bars and venues hiring bartenders in Las Vegas.',
      robots: 'index,follow',
    });

    const cleanupSchema = applyStructuredData([
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://barsconnect.com/' },
          { '@type': 'ListItem', position: 2, name: 'Bartender Jobs', item: 'https://barsconnect.com/bartender-jobs' },
          { '@type': 'ListItem', position: 3, name: 'Las Vegas, NV', item: 'https://barsconnect.com/bartender-jobs-las-vegas-nv' },
        ],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'JobPosting',
        title: 'Bartender Jobs in Las Vegas, NV',
        description: 'Flexible bartender opportunities in Las Vegas, NV through BarsConnect.',
        employmentType: 'CONTRACTOR',
        hiringOrganization: {
          '@type': 'Organization',
          name: 'BarsConnect Partner Bars',
          sameAs: 'https://barsconnect.com',
        },
        jobLocation: {
          '@type': 'Place',
          address: {
            '@type': 'PostalAddress',
            addressLocality: 'Las Vegas',
            addressRegion: 'NV',
            addressCountry: 'US',
          },
        },
      },
    ]);

    return () => {
      cleanupMeta();
      cleanupSchema();
    };
  }, []);

  return (
    <div className="min-h-screen py-12 px-4 sm:px-6 lg:px-8" data-testid="las-vegas-landing-page">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold text-white mb-3" data-testid="las-vegas-page-title">Bartender Jobs in Las Vegas, NV</h1>
        <p className="text-muted-foreground mb-8" data-testid="las-vegas-page-subtitle">
          Explore high-energy bartender shifts in casinos, lounges, clubs, and events throughout Las Vegas.
        </p>
        <Card className="bg-white/5 border border-white/10" data-testid="las-vegas-cta-card">
          <CardContent className="p-6">
            <p className="text-sm text-muted-foreground mb-4" data-testid="las-vegas-cta-copy">
              Build your bartender profile once and get discovered faster by venues hiring for peak hours and major events.
            </p>
            <div className="flex flex-wrap gap-3">
              <Button asChild data-testid="las-vegas-create-profile-btn"><Link to="/register/bartenders">Create Free Bartender Profile</Link></Button>
              <Button asChild variant="outline" data-testid="las-vegas-browse-bartenders-btn"><Link to="/bartenders">Browse Bartenders</Link></Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
